angular.module('admin')
  .controller('LoggedInUserCtrl', ['$q', '$scope', 'AccountService', 'SessionService', 'AgentService', 'AuthResolver', 'SSOService',
    function($q, $scope, AccountService, SessionService, AgentService, AuthResolver, SSOService){

    $scope.accountService = AccountService;
    $scope.SessionService = SessionService;

    $scope.groups = [];

    $scope.retrieveGroups = function () {
      const jwt = SessionService.extractJWT();

      if (_.get(jwt, 'acr.values[0]')) {
        const groupPromises = []
        const values = jwt.acr.values;
        const agentId = AccountService.getAgent('id')

        values.forEach(value => {
          if (!value.context) return;

          const [type, _id] = value.context.split(':');
          if (type === 'company') {
            groupPromises.push(AgentService.getBrokerage(agentId));
          }
        })

        $q.all(groupPromises).then(groups => {
          $scope.groups = groups;
        })
      }
    };

    $scope.showTrialBanner = false;

    $scope.checkTrialStatus = function () {
      if (AccountService.getAgent('hasCosponsorship')) {
        return $scope.showTrialBanner = false;
      }

      return $scope.showTrialBanner = false;
      // TODO: Figure out way to get this subscription info from the customer
      // let planCode
      // let planStartedAt
      // if (planCode && planStartedAt) {
      //   const isBabAgent = planCode === 'bab-agent-starter';
      //   const trialStartDate = planStartedAt;
      //   const daysSinceTrialStartDate = moment().utc().diff(trialStartDate, 'days');
      //   const daysInTrial = isBabAgent ? 90 : 30
      // 
      //   $scope.isBabAgent = isBabAgent;
      //   $scope.showTrialBanner = true;
      //   $scope.trialDaysLeft = Math.max(0, daysInTrial - daysSinceTrialStartDate);
      // }
    };

    $scope.init = function () {
      AuthResolver.identifyUser().then(() => {
        $scope.retrieveGroups();
        $scope.checkTrialStatus();
      });
    };

    $scope.init();
  }]);
